import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` This article only applies to users of the public npm registry.`}</p>
    </Note>
    <p>{`You can update the credit card used to pay for your paid user account plan. Updating your credit card will not change your billing cycle date, and the new credit card will be charged on the next billing cycle.`}</p>
    <><strong>Note:</strong> If the credit card used to pay for your paid user account plan expires, or we are otherwise are unable to charge your card, you have a grace period of {shared['grace-period'].text} to update the card.</>
    <h2>{`Updating credit card information`}</h2>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-info'].text}</>
        <>{shared['billing-info'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['payment-info'].text}</>
        <>{shared['payment-info'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-form'].text}</>
        <>{shared['billing-form'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['payment-info-button'].text}</>
        <>{shared['payment-info-button'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-creditcard-form'].text}</>
        <>{shared['billing-creditcard-form'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['payment-remember-me'].text}</>
        <>{shared['payment-remember-me'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-update-card'].text}</>
        <>{shared['billing-update-card'].image}</>
      </li>
    </ol>
    <h2>{`Updating billing receipt email and extra receipt information`}</h2>
    <p>{`You can update the email address used for receipts, and add extra information to the receipt for your paid user account plan, such as your business name, VAT identification number, or address of record. Updated billing information will appear on all receipts immediately.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` The billing email is used for receipts only and is not required to match the email address of the person whose card is used to pay for the paid user account plan.`}</p>
    </Note>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-info'].text}</>
        <>{shared['billing-info'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-history'].text}</>
        <>{shared['billing-history'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-receipt-settings'].text}</>
        <>{shared['billing-receipt-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-extra-info'].text}</>
        <>{shared['billing-extra-info'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-extra-receipt-email'].text}</>
        <>{shared['billing-extra-receipt-email'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-extra-save'].text}</>
        <>{shared['billing-extra-save'].image}</>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      